import React, { useMemo } from 'react';
import { isMobile, notificationStore } from '@pascal/pascal-core';
import { AdditionalInputValueChangingButtons } from '@pascal/pascal-core/shared/core/enums/additionalInputValueChangingButtons';

import { quickButtonsValue } from '../../../enums/quickButtonsValue';

export const BetAmountSection = ({
  t,
  limits,
  isDemo,
  betAmount,
  setBetAmount,
  activeFreeBet,
  handleInputBlur,
  handleShowNumpad,
  setIsValidatedAmount,
  handleChangeInputValue,
}) => {
  const betValues = useMemo(() => {
    return ['MIN', 3, '1/2', 2];
  }, []);

  return (
    <div className='w-md-bet-calc-inner'>
      <div className='w-md-bet-calc-field'>
        <button
          type='button'
          className={`w-md-bet-calc-nav ${activeFreeBet.id ? 'disabled' : ''}`}
          data-role='minus'
          onClick={
            !activeFreeBet.id ? () => handleChangeInputValue(AdditionalInputValueChangingButtons.minus) : undefined
          }
        >
          <i className='ui-lib-minus' />
        </button>
        <label className='w-md-calc-num'>
          <input
            type='text'
            maxLength={9}
            autoComplete='off'
            readOnly={isMobile()}
            className={`w-md-calc-num ${activeFreeBet.id ? 'disabled' : ''}`}
            disabled={activeFreeBet.id}
            title={`${betAmount || ''}`}
            inputMode={isMobile() ? 'none' : 'text'}
            onClick={(e) => {
              if (isMobile()) {
                e.stopPropagation();
                document.activeElement.blur();
                handleShowNumpad(true);
              }
            }}
            value={betAmount || ''}
            onBlur={() => {
              const { validatedBetAmount, errorMessageCode } = handleInputBlur(betAmount);
              if (errorMessageCode) {
                notificationStore.setNotificationType({ responseCode: errorMessageCode });
                setIsValidatedAmount(true);
              }
              setBetAmount(validatedBetAmount);
            }}
            onChange={(e) => {
              if (!/^[.,]/.test(e.target.value) && /^\d*[.,]?\d*$/.test(e.target.value) && !activeFreeBet.id) {
                setBetAmount(e.target.value.replace(',', '.'));
              }
            }}
            {...(isMobile() ? { onClick: (e) => handleShowNumpad(e) } : {})}
          />
        </label>
        <button
          type='button'
          className={`w-md-bet-calc-nav ${activeFreeBet.id ? 'disabled' : ''}`}
          onClick={
            !activeFreeBet.id ? () => handleChangeInputValue(AdditionalInputValueChangingButtons.plus) : undefined
          }
          data-role='plus'
        >
          <i className='ui-lib-plus' />
        </button>
      </div>
      <div className='w-md-bet-nums'>
        {betValues.map((value) => (
          <button
            className={`w-md-bet-num ${
              (activeFreeBet.id && !isDemo) || (value === 'MIN' && limits.minBet === +betAmount) ? 'disabled' : ''
            }`}
            key={value}
            type='button'
            onClick={() => {
              const buttonValue = quickButtonsValue[value];
              handleChangeInputValue(
                AdditionalInputValueChangingButtons[buttonValue],
                value === 2 || value === '1/2' ? 2 : 3
              );
            }}
          >
            {/* add/remove class "disabled" || "active" */}
            <span className='md-calc-variant-text'>{Number.isInteger(value) ? `x${value}` : t(value)}</span>
          </button>
        ))}
      </div>
    </div>
  );
};
